import HeaderWrapper from '@/components/common/Header/HeaderWrapper';
import { Button } from '@/components/ui/button';
import { getRoutes } from '@/routes/routePaths';
import { useStripe } from '@stripe/react-stripe-js';
import { ArrowLeft, CircleCheckBig, CircleX, Info } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const STATUS_CONTENT_MAP: any = {
  succeeded: {
    text: 'Thank you for your purchase',
    iconColor: '#30B130',
    icon: <CircleCheckBig className='w-40 h-40 text-[#30B130]' />,
  },
  processing: {
    text: 'Your payment is processing.',
    iconColor: '#6D6E78',
    icon: <Info className='w-40 h-40 text-[#6D6E78]' />,
  },
  ['requires_payment_method']: {
    text: 'Your payment was not successful, please try again.',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
  ['requires_capture']: {
    text: 'Something went wrong, please try again.1',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
  ['requires_action']: {
    text: 'Something went wrong, please try again.2',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
  ['requires_confirmation']: {
    text: 'Something went wrong, please try again.3',
    iconColor: '#DF1B41',
    icon: <CircleX className='w-40 h-40 text-[#DF1B41]' />,
  },
};

export default function CompletePage({ clientSecret }: { clientSecret: string | null }) {
  const navigate = useNavigate();
  const stripe = useStripe();
  const [status, setStatus] = useState('');
  const [intentId, setIntentId] = useState('');

  const handleGoBack = () => {
    navigate(getRoutes.Subscription);
  };
  useEffect(() => {
    if (!stripe) {
      return;
    }

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      if (!paymentIntent) {
        return;
      }
      setStatus(paymentIntent.status);
      setIntentId(paymentIntent?.id);
    });
  }, [stripe]);

  return (
    <div className='flex min-h-screen w-full flex-col overflow-auto'>
      <HeaderWrapper className='fixed top-0 z-50 w-full flex-col gap-2 md:flex-row'>
        <div className='flex w-full min-w-0 items-center gap-2 px-3 sm:px-4'>
          <Button
            onClick={handleGoBack}
            id='session-details-back-btn'
            variant='ghost'
            size='icon'
            className='shrink-0 text-white'
          >
            <ArrowLeft className='h-5 w-5' />
          </Button>
          <h1 className='truncate text-base font-semibold sm:text-lg'>Back to Subscription</h1>
        </div>
      </HeaderWrapper>
      <main
        id='payment-status'
        className='mx-auto mt-20 flex w-full max-w-2xl flex-1 flex-col px-4 pb-10 pt-2 sm:mt-24 sm:px-6 md:mt-28 md:pb-16'
      >
        <div className='flex flex-col items-center gap-4 p-4 sm:gap-5 sm:p-6 md:p-7'>
          {status ? (
            <>
              <div
                id='status-icon'
                className='[&_svg]:h-24 [&_svg]:w-24 sm:[&_svg]:h-32 sm:[&_svg]:w-32 md:[&_svg]:h-40 md:[&_svg]:w-40'
              >
                {STATUS_CONTENT_MAP[status].icon}
              </div>
              <h2
                id='status-text'
                className='max-w-full px-1 text-center text-lg sm:text-xl md:text-2xl'
              >
                {STATUS_CONTENT_MAP[status].text}
              </h2>
            </>
          ) : (
            <div className='h-32 sm:h-40 md:h-48' />
          )}
          <div className='flex w-full max-w-full flex-col items-center gap-1 text-center sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-2 sm:gap-y-1'>
            <p className='shrink-0 text-sm sm:text-base'>Transaction ID:</p>
            <p className='w-full break-all font-mono text-sm sm:w-auto sm:max-w-full sm:text-base'>
              {intentId}
            </p>
          </div>
          <Button
            id='schedule-session-cancel-btn'
            variant='secondary'
            onClick={() => handleGoBack()}
            className='w-full max-w-xs sm:w-52'
          >
            Go to Subscription
          </Button>
        </div>
        {/* <Separator className='bg-[#FFFFFF21]' />
      <div className='flex items-center justify-end gap-4 w-full p-7'>
        <Button id='schedule-session-cancel-btn' variant='secondary' onClick={() => handleClose()}>
          Close
        </Button>
      </div> */}
      </main>
    </div>
  );
}
